import React from 'react';
import Sectiontitle from '../section-title';
import { useSiteSettings, resolveMediaUrl } from '../../siteSettings';
import './style.css';

const Story = () => {
    const settings = useSiteSettings();
    const section = settings.storySection;
    if (!section || !section.title) return null;

    return (
        <div id="story" className="story-area section-padding">
            <Sectiontitle section={section.title} />
            <div className="container">
                <div className="story-wrap">
                    {(section.items || []).map((item, index) => (
                        <div className="row story-event-row" key={`${item.title}-${index}`}>
                            {index % 2 === 0 && <div className="col-lg-6 col-md-12 col-12 pr-n story-image-column">
                                <div className="story-img"><img src={resolveMediaUrl(item.image)} alt="" /></div>
                            </div>}
                            <div className={`col-lg-6 col-md-12 col-12 story-text-column ${index % 2 ? 'order-lg-1' : ''}`}>
                                <div className={`story-text ${index % 2 ? 'right-align-text' : 'left-align-text'}`}>
                                    <h3>{item.title}</h3>
                                    <span className="date">{item.date}</span>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                            {index % 2 === 1 && <div className="col-lg-6 col-md-12 col-12 pl-n order-lg-2 story-image-column">
                                <div className="story-img"><img src={resolveMediaUrl(item.image)} alt="" /></div>
                            </div>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Story;
